import React, { useEffect, useRef, useState, useContext } from "react";

import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Dropdown } from "primereact/dropdown";
import { confirmDialog } from "primereact/confirmdialog";

import Card from "../../../../Base/Components/Card/Card";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import { setTitlePage } from "../../../../Base/Services/Config/ConfigService";
import { downloadFile, uploadHandlerFoto } from "../../../../Base/Services/ArchivosService";
import { toastShow } from "../../../../Base/Services/ToastService";
import ImagenCRUD from "../../../../Base/Components/Dialog/ImagenCRUD";

import { descargarFotos, mostrarFoto, getFoto, eliminarFotoPersonal } from "../../../../Base/API/IT/Users/UserRequests";
import { chageEstadoPersonal, getPersonall } from "../../../../API/RRHH/Personal/PersonalRequest";
import { getEstadosCategory } from "../../../../API/Global/Status/StatusRequests";

import PersonalCRUD from "./PersonalCRUD";

const PersonalScreen = () => {
  const toast = useRef(null);
  const fileUpload = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [personal, setPersonal] = useState([]);
  const [selected, setSelected] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [showImagen, setShowImagen] = useState(false);
  const [listadoArchivos, setListadoArchivos] = useState([]);
  const [showDialogEliminar, setShowDialogEliminar] = useState(false);
  const [eliminarFoto, setEliminarFoto ] = useState([]);
  const [imagenes, setImagenes] = useState([]);
  const [estados, setEstados] = useState([]);

  const getInfo = async () => {
    setLoading(true);
    const pos = await getPersonall();
    setPersonal(pos);
    const estadosTempo = await getEstadosCategory('General')
    setEstados(estadosTempo.filter(i => i?.IdStatus !== 7))
    setLoading(false);
  };

  const changeEstado = ({ data, api }) => {
    return (
      <div>
        <Dropdown
          value={estados.filter((e) => e.IdStatus === data.IdEstado)}
          options={estados}
          optionLabel="StatusName"
          filter
          filterBy="StatusName"
          style={{ width: "100%" }}
          onChange={(e) => {
            let changes = [];
            changes.push({
              IdPersonal: data.IdPersonal,
              IdStatus: e.value.IdStatus,
              StatusName: e.value.StatusName,
            });
            confirmDialog({
              message: `¿Cambiar a estado ${e.value.StatusName} a ${changes.length} ${changes.length > 1 ? 'Personas' : 'Persona'} ?`,
              header: "Confirmación",
              icon: "pi pi-exclamation-triangle",
              accept: async () => {
                let IdPersonales = changes.map((item) => item.IdPersonal);
                cambiarEstado(e.value.IdStatus, IdPersonales.toString());
                getInfo();
                api.stopEditing();
              },
              reject: () => {},
            });
          }}
        />
      </div>
    );
  };

  const cambiarEstado = async (IdStatus, IdPersonales) => {
    const result = await chageEstadoPersonal({ IdStatus, IdPersonales });
    toastShow(toast, "success", "Actualizado", "Estado cambiado exitosamente");
  };

  const columns = [
    {
      field: "IdPersonal",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "CodigoPersonal",
      header: "Código",
      headerEn: "Code",
      className: "Xsmall",
      Format: 'Modal',
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
      Sumary: 'count',
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      className: "Xsmall",
      Format: "Estado",
      filter: false,
      body: (rowData) => ({
        ID: rowData.StatusName,
        Estado: rowData.StatusName,
      }),
      cellEditor: changeEstado,
      editable: (rowData) => {
        if(rowData.data?.IdPersonal){
          return true
        }else{
          return false
        }
      }
    },
    {
      field: "Nombre",
      header: "Nombre",
      headerEn: "Name",
      className: "Xlarge",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Apellido",
      header: "Apellido",
      headerEn: "Lastname",
      className: "Xlarge",

      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Sexo",
      header: "Sexo",
      headerEn: "Sex",
      className: "small",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Cedula",
      header: "Cedula",
      headerEn: "Identity",
      className: "Xlarge",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "FechaIngreso",
      header: "Fecha de Ingreso",
      headerEn: "Date of admission",
      className: "small",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Area",
      header: "Area",
      headerEn: "Area",
      className: "Xlarge",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Posicion",
      header: "Posición",
      headerEn: "Position",
      className: "Xlarge",

      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "FechaNacimiento",
      header: "Fecha de Nacimiento",
      headerEn: "Birthdate",
      className: "small",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Direccion",
      header: "Direccion",
      headerEn: "Address",
      className: "Xlarge",

      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Correo",
      header: "Correo",
      headerEn: "Email",
      className: "Xlarge",

      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "EstadoCivil",
      header: "Estado Civil",
      headerEn: " Civil Status",
      className: "large",

      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "RTN",
      header: "RTN",
      headerEn: "RTN",
      className: "Xlarge",

      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "NombreSuperior",
      header: "Superior",
      headerEn: "Superior",
      className: "Xlarge",

      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "ApellidoSuperior",
      header: "Superior",
      headerEn: "Superior",
      className: "Xlarge",

      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "IdPersonal",
      className: "colum-width-small",
      header: "",
      Format: "Botones",
      filter: false,
      alignFrozen: "right",
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            setShowDialog(true);
            setSelected(rowData);
          },
          tooltipOptions: {
            position: "right",
          },
        },
        {
          icon: "pi pi-user",
          tooltip: "Agregar Imágen",
          onClick: (rowData) => {
            setShowImagen(true);
            setSelected(rowData);
          },
          tooltipOptions: {
            position: "left",
          },
        },
      ],
    },
  ];

  const table = {
    Columns: columns,
    Data: personal,
    loading: loading,
    showModal: (e) => {},
  };

  // IMAGENES
  const referencia = {
    IdRef: selected?.IdPersonal,
    Codigo: selected?.CodigoPersonal,
  };

  const subirFoto = async (e) => {
    const archivosGuardados = await getImagenes();
    if (imagenes?.img) {
      toastShow(toast, "error", "Error", "Solo se permite subir 1 imágen.");
      return;
    }
    const inputs = [
      {
        name: "IdRef",
        type: "text",
        value: referencia.IdRef,
      },
      {
        name: "Codigo",
        type: "text",
        value: referencia.Codigo,
      },
    ];
    uploadHandlerFoto({ e, inputs, toast, ref: fileUpload, getImagenes });
    getImagenes();
  };

  const getImagenes = async () => {
    const i = await getFoto(selected?.CodigoPersonal);
    if (i?.length > 0) {
      const imagenCorrespondiente = i.find((e) => e.startsWith(selected?.CodigoPersonal));
      imagenCorrespondiente ? setListadoArchivos([imagenCorrespondiente]) : setListadoArchivos([]);
      if (imagenCorrespondiente) {
        const a = await mostrarFoto( selected?.CodigoPersonal, imagenCorrespondiente );
        setImagenes({ Codigo: selected?.CodigoPersonal, img: [a] });
      } else {
        setImagenes([]);
      }
    }
  };

  const descargarFoto = async (nombre) => {
    const a = await descargarFotos(selected?.CodigoPersonal, nombre);
    downloadFile(a, nombre);
  };

  const eliminar = async () => {
    const a = await eliminarFotoPersonal(selected?.CodigoPersonal, eliminarFoto);
    toastShow(toast, "success", "Eliminada", "Imágen eliminada correctamente.");
    setListadoArchivos(listadoArchivos.filter((archivo) => archivo !== eliminarFoto));
    setShowDialogEliminar(false)
    setEliminarFoto([])
    setImagenes([])
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "personalRRHH", config.language));
    getInfo();
  }, []);

  return (
    <div
      className=" p-fluid px-4"
      style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "personalRRHH", config.language)}</h3>
            <Button icon="pi pi-refresh" onClick={getInfo} />
            <Button
              icon="pi pi-plus"
              onClick={() => {
                setShowDialog(true);
                setSelected(null);
              }}
            />
          </div>
        }
        contenido={
          <div className="p-4" style={{ height: "90vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />

      {showDialog && (
        <PersonalCRUD
          toastRef={toast}
          showDialog={showDialog}
          selected={selected}
          setShowDialog={setShowDialog}
          getInfo={getInfo}
          modo={selected ? "Editar" : "Crear"}
        />
      )}
      
      {showImagen && (
        <ImagenCRUD
          fileUpload={fileUpload}
          showDialogFoto={showImagen}
          setShowDialogFoto={setShowImagen}
          getInfo={getInfo}
          selected={selected}
          setSelected={setSelected}
          subirArchivo={subirFoto}
          getArchivos={getImagenes}
          descargar={descargarFoto}
          eliminar={eliminar}
          showDialogEliminar={showDialogEliminar}
          setShowDialogEliminar={setShowDialogEliminar}
          setEliminarFoto={setEliminarFoto}
          loading={loading}
          imagenes={imagenes}
          listadoArchivos={listadoArchivos}
          title={`Agregar Foto -  ${selected?.NombreCompleto}`}
        />
      )}
    </div>
  );
};

export default PersonalScreen;
